import { authentificationRepository } from '../repositories/authentication-repository';

async function verifyOtp({ email, code }) {
    const data = await authentificationRepository.verifyOtp({ email, code });

    return data;
}

export {
    verifyOtp
};
